import { Pipe, PipeTransform } from '@angular/core';
import { configureMarkdown, parseMarkdown } from '@genesys/genesysmarkdown';
import { GenesysUrlReplaceService } from 'shared/services/genesys-url-replace/genesys-url-replace.service';

@Pipe({
  name: 'appMdToHtml'
})
export class MdToHtmlPipe implements PipeTransform {
  constructor() {
    configureMarkdown({ enabled: true });
  }

  transform(
    value: string,
    options: { replaceLinksWithPlainText: boolean } = { replaceLinksWithPlainText: false }
  ): string {
    if (!value) {
      return '';
    } else {
      const parsedText = parseMarkdown({ text: value });
      return options.replaceLinksWithPlainText ? GenesysUrlReplaceService.replaceLinkWithUrl(parsedText) : parsedText;
    }
  }
}
